import MessagingBroadcastModal from './MessagingBroadcastModal';

export default MessagingBroadcastModal;
